import {Component} from "react";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import './Perimeters.css'
import PeriEditModal from "./PeriEditModal.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import AppGestionePerimetriIcon from "../../../media/app-images/AppGestionePerimetriIcon.mjs";
import PerimetersList from "../../../ComponentParts/Perimeters/PerimetersList.mjs";
import {Button, ButtonGroup} from "reactstrap";
import AppUploadIcon from "../../../media/app-images/AppUploadIcon.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";

const prefix = "Perimeters";

const Perimeters = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			by: Glob.getPageParam('by'),
			ll: Glob.getLanguageLong(),
			changed: Date.now()
		}
		this.uid = Glob.generateUid(prefix);
		this.savePeri = this.savePeri.bind(this);
	}

	componentDidMount() {
		Glob.setStatus('pageTitle', ['Perimeters', "Available perimeters"]);
		Glob.setStatus('pageIcon', <AppPerimeterIcon/>);
		Glob.register('Prefs', () => {
			const ll = Glob.getLanguageLong();
			if (ll !== this.state.ll) this.setState({ll: ll} );
		}, this.uid)
	}

	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	async savePeri(peri) {
		if ( peri ) {
			const payload = {
				id: peri.id,
				name: peri.name,
				description: peri.description
			};
			await appLib.api('perimetri/edit-info', payload);
		}
		this.setState({periEdit: undefined, changed: Date.now()});
	}

	render() {
		return (
			<SliderPanel
				icon={<AppGestionePerimetriIcon/>}
				title={<TextLabel value={"Available perimeters"}/>}
				className={prefix}
			>
				<div className={"panel-content limited"}>
					<PerimetersList
						key={ this.state.changed }
						onClick={ p => { this.setState({periEdit: p}); return false; }}
					/>
				</div>
				{ appLib.enabled() && (
					<div className={"panel-footer"}>
						<ButtonGroup className={"btn-icon"}>
							<Button
								color={"success"}
								onClick={ ()=>{ Glob.gotoPage('RealPeriUpload')} }
							>
								<i>
									<AppUploadIcon/>
								</i>
								<b className={"no-mobile"}>
									<TextLabel value={"Upload real data"}/>
								</b>
							</Button>
							<Button
								color={"success"}
								onClick={ ()=>{ Glob.gotoPage('SynthUpload')} }
							>
								<b className={"no-mobile"}>
									<TextLabel value={"Upload synthetic data"}/>
								</b>
								<i>
									<AppSynthDataIcon/>
								</i>
							</Button>
						</ButtonGroup>
						<div />
					</div>
				)}
				{this.state.periEdit && (
					<PeriEditModal
						close={() => { this.setState({ periEdit: undefined }); }}
						save={ this.savePeri }
						peri={ this.state.periEdit }
					/>
				)}
			</SliderPanel>
		)
	}
}

export default Perimeters;
